import get from 'lodash/get';
import { logout } from '../utils/auth';

const checkSession = () => next => action => {
  // if user is not authenticated, make sure to log them out and redirect
  // them to the homepage
  if (action.error === true && get(action, 'payload.status') === 401) {
    return logout();
  }

  return next(action);
};

export default checkSession;
